import React, { useEffect, useState } from "react";
import { SelectInput, TextInput } from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { history } from "../../_helpers";
import { useDispatch, useSelector } from "react-redux";
import { authActions, eCardAction } from "../../_store";
import CustomLoader from "../../components/common/ui/Loader";
import uploadicon from "../../assets/svg/btn_icons/create-btn-icon.svg";
import Activeicon from "../../assets/svg/approved.svg";
import Inactiveicon from "../../assets/svg/inactive-user.svg";
import Swal from "sweetalert2";

function ECardCategory() {
  const dispatch = useDispatch();

  const [showSearchFields, setShowSearchFields] = useState(false);
  const { monthList, podStatusOptions } = useSelector(
    (x) => x?.dropdownOptions
  );
  const user = useSelector((x) => x.auth.user);
  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const { EcardCategorySearchData, eCardCategoryList, loading } = useSelector(
    (x) => x?.ecard
  );

  let sorting = false;
  // const [searchData, setSearchData] = useState({
  // categoryId: 0,
  // categoryName: "",
  // fromMonth: "",
  // toMonth: "",
  // isActive: 2,
  // pageNo: 1,
  // rowCountPerPage: 10,
  // sortBy: "",
  // });


  /* E-Card category list */
  useEffect(() => {
    dispatch(eCardAction?.getECardCategoryList(EcardCategorySearchData))
      .then((result) => {
        if (result?.payload?.DataList?.length === 0) {
          const searchParams = { ...EcardCategorySearchData };
          searchParams.pageNo = 1;
          searchParams.rowCountPerPage = 10;
          dispatch(eCardAction?.updateEcardSearch(searchParams));
          dispatch(eCardAction?.getECardCategoryList(searchParams));
        }
      })
      .catch((err) => { });
  }, [
    EcardCategorySearchData?.rowCountPerPage,
    EcardCategorySearchData?.pageNo,
    EcardCategorySearchData?.sortBy,
    isPageReloading,
  ]);

  const columns = [
    {
      name: "Name",
      key: "CategoryName",
      selector: (row) => row.CategoryName,
      cell: (row) => (
        <div
          className="Common_Link_Style"
          onClick={() => {
            navigateToEditPage(row);
          }}
        >
          {row.CategoryName}
        </div>
      ),
      sortable: true,
    },
    {
      // width: "210px",
      name: "From",
      key: "FromMonth",
      selector: (row) => row.MonthRange,
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          <div className="">{getMonthNameFromRange(row.FromMonth, "from")}</div>
          {/* <div className="">{row.FromMonth}</div> */}
        </div>
      ),
      sortable: true,
    },
    {
      // width: "210px",
      name: "To",
      key: "ToMonth",
      selector: (row) => row.MonthRange,
      sortable: true,
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          <div className="">{getMonthNameFromRange(row.ToMonth, "to")}</div>
        </div>
      ),
    },

    {
      // width: "120px",
      name: "Status",
      key: "IsActive",
      selector: (row) => row.IsActive,
      sortable: true,
      cell: (row) => (
        // <div className="">{row.IsActive ? "Active" : "In-active"}</div>
        <img
          title={row.IsActive === 1 ? "Active" : "Inactive"}
          src={row.IsActive === 1 ? Activeicon : Inactiveicon}
          alt={row.IsActive === 1 ? "Active" : "Inactive"}
          className="in-icon-size"
        />
      ),
    },
  ];

  const navigateToEditPage = (row) => {
    Swal?.close();
    const { CategoryId } = row;
    history.navigate(`/Admin/E-Cards/Category/AddOrEdit`, {
      state: {
        CategoryId: CategoryId,
      },
    });
  };

  const getMonthNameFromRange = (month, range) => {
    if (!month || month?.length === 0) return "-";
    // const getIndex = range === "from" ? 0 : month?.length - 1;
    const monthName = monthList[month];
    return monthName?.label;
  };

  const handleSeacrhDataChange = (e, select) => {
    const updateSearch = { ...EcardCategorySearchData };
    if (select) {
      updateSearch[select] =
        e !== null ? e?.value : select === "isActive" ? 2 : 0;

      // setSearchData(updateSearch);
      // if (select !== "isActive") {
      updateSearch.pageNo = 1;
      updateSearch.rowCountPerPage = 10;
      // }
      dispatch(eCardAction?.updateEcardSearch(updateSearch));
      dispatch(eCardAction?.getECardCategoryList(updateSearch));
      return;
    }
    const { name, value } = e?.target;
    if (value.startsWith(" ")) return;
    const isValid = /^[a-zA-Z0-9 ']*$/.test(value);
    if (!isValid) return;
    updateSearch[name] = value;
    dispatch(eCardAction?.updateEcardSearch(updateSearch));
    // setSearchData(updateSearch);
  };

  //   const handleSeacrhDataChange = (e, select) => {
  //   const updateSearch = { ...EcardCategorySearchData };

  //   if (select) {
  //     updateSearch[select] =
  //       e !== null ? e?.value : select === "isActive" ? 2 : 0;
  //   } else {
  //     const { name, value } = e?.target;
  //     if (value.startsWith(" ")) return;
  //     const isValid = /^[a-zA-Z0-9 ]*$/.test(value);
  //     if (!isValid) return;
  //     updateSearch[name] = value;
  //   }

  //   // Add pagination defaults
  // updateSearch.pageNo = 1;
  // updateSearch.rowCountPerPage = 10;

  //   dispatch(eCardAction?.updateEcardSearch(updateSearch));
  //   dispatch(eCardAction?.getECardCategoryList(updateSearch));
  // };

  const handleRowPerPage = (page) => {
    const updateSearch = { ...EcardCategorySearchData };
    updateSearch.rowCountPerPage = page;
    updateSearch.pageNo = 1;
    dispatch(eCardAction?.updateEcardSearch(updateSearch));
    // setSearchData(updateSearch);
    // dispatch(eCardAction?.getECardCategoryList(updateSearch));
    // dispatch(eCardAction?.setPhotosSearch(updateSearch));
  };

  const handlePageChange = (page) => {
    if (sorting) {
      sorting = false;
      return;
    }
    const updateSearch = { ...EcardCategorySearchData };
    updateSearch.pageNo = page;
    dispatch(eCardAction?.updateEcardSearch(updateSearch));
    // setSearchData(updateSearch);
    // dispatch(eCardAction?.getECardCategoryList(updateSearch));
    // dispatch(eCardAction?.setPhotosSearch(updateSearch));
  };

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...EcardCategorySearchData };
    const newSortOrder = search.sortBy?.includes(column.key)
      ? search.sortBy.endsWith("ASC")
        ? "DESC"
        : "ASC"
      : "ASC";
    search.sortBy = `${column.key} ${newSortOrder}`;
    dispatch(eCardAction?.updateEcardSearch(search));
    // setSearchData(search);
    // dispatch(photoAction?.setPhotosSearch(search));
  };

  const handleSearchReset = () => {
    const resetSearch = {
      categoriesId: 0,
      categoryName: "",
      fromMonth: 0,
      toMonth: 0,
      isActive: 2,
      pageNo: 1,
      rowCountPerPage: 10,
      sortBy: "",
    };
    dispatch(eCardAction?.updateEcardSearch(resetSearch));
    // setSearchData(resetSearch);
    dispatch(eCardAction?.getECardCategoryList(resetSearch));
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    const search = {
      ...EcardCategorySearchData,
      pageNo: 1,
      rowCountPerPage: 10,
    };
    dispatch(eCardAction?.getECardCategoryList(search));
    dispatch(eCardAction?.updateEcardSearch(search));
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const handleCategoryPage = () => {
    Swal?.close();
    history.navigate("/Admin/E-Cards/Category/AddOrEdit", {
      state: {
        CategoryId: 0,
      },
    });
  };

  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleSearchSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="categoryName"
                id="categoryName"
                label="Category Name"
                value={EcardCategorySearchData?.categoryName}
                placeholder="Enter Category Name"
                maxLength={50}
                handleChange={(e) => handleSeacrhDataChange(e)}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="fromMonth"
                options={monthList}
                isMulti={false}
                closeMenuOnSelect={true}
                isClearable={EcardCategorySearchData?.fromMonth !== 0}
                label="Start Month"
                placeholder="Select Status"
                value={EcardCategorySearchData?.fromMonth}
                handleChange={(e) => handleSeacrhDataChange(e, "fromMonth")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="toMonth"
                options={monthList}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={EcardCategorySearchData?.toMonth !== 0}
                label="End Month"
                placeholder="Select Status"
                value={EcardCategorySearchData?.toMonth}
                handleChange={(e) => handleSeacrhDataChange(e, "toMonth")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="isActive"
                options={podStatusOptions}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={EcardCategorySearchData?.isActive !== 2}
                label="Status"
                placeholder="Select Status"
                value={EcardCategorySearchData?.isActive}
                handleChange={(e) => handleSeacrhDataChange(e, "isActive")}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={handleSearchReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };
  if (loading) return <CustomLoader />;
  return (
    <div className="e-card-category">
      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
        <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
          {/* Mobile only (Below md breakpoint) */}
          <div className=" d-block d-md-none">
            <div
              className=" d-flex align-items-center justify-content-between"
              style={{ background: "transparent", cursor: "pointer" }}
              onClick={toggleInformation}
            >
              <h2 className="form_title_uppercase text-color">
                E-Card category search
              </h2>
              <i
                id="itagInformation"
                className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                  }`}
                style={{ fontSize: "20px" }}
              ></i>
            </div>
          </div>
          {/* Mobile only (Below md breakpoint) */}
          <div className="d-block d-md-none mt-2">
            {showSearchFields && renderSearch()}
          </div>

          {/* Web only (Desktop and above) */}
          <div className="mb-3 d-none d-md-block">
            <h2 className="form_title_uppercase text-color">
              E-Card category search
            </h2>
          </div>
          {/* Web only (Desktop and above) */}
          <div className="d-none d-md-block">{renderSearch()}</div>
        </div>

        <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
            <h2 className="text-color">E-CARD CATEGORIES LIST</h2>

            <div className="d-flex flex-wrap  align-items-center gap-3">
              <Button
                variant="success"
                className="me-2"
                label="add category"
                type="button"
                imgsrc={uploadicon}
                status="btn-label"
                onClick={() => {
                  handleCategoryPage();
                }}
              />
            </div>
          </div>

          <Table
            columns={columns}
            data={eCardCategoryList?.DataList}
            pagination
            onChangeRowsPerPage={handleRowPerPage}
            onChangePage={handlePageChange}
            totalRowCount={eCardCategoryList?.TotalRecordCount}
            currentPage={EcardCategorySearchData?.pageNo}
            paginationPerPage={EcardCategorySearchData.rowCountPerPage}
            onSort={handleSort}
            serverSideSort
            sortColumn={EcardCategorySearchData?.sortBy?.split(" ")[0]}
            sortDirection={EcardCategorySearchData?.sortBy?.split(" ")[1]}
          />
        </div>
      </div>
    </div>
  );
}

export default React.memo(ECardCategory);
